module.exports = __webpack_public_path__ + "img/frame (274).59f6639a.jpg";